import { CoreIcon } from '../core-icon';
import pointCircleFillSVG from '../../assets/icons/point-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const PointCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pointCircleFillSVG} {...props} />;
};
